function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

function parsePercentFromStrong(strongEl) {
  if (!strongEl) return null;
  const raw = (strongEl.textContent || '').trim();
  const match = raw.match(/-?\d+(?:[.,]\d+)?/);
  if (!match) return null;
  const normalized = match[0].replace(',', '.');
  const value = Number.parseFloat(normalized);
  if (!Number.isFinite(value)) return null;
  return clamp(value, 0, 100);
}

function enhancePercentageLists(root = document) {
  const blocks = root.querySelectorAll('.percentage');
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const items = block.querySelectorAll('li');
    items.forEach((li) => {
      if (li.dataset.tsPercentEnhanced === '1') return;

      const strong = li.querySelector(':scope > strong:first-child');
      const p = parsePercentFromStrong(strong);
      if (p === null) return;
      li.style.setProperty('--p', String(p));

      const ring = document.createElement('span');
      ring.className = 'ts-percent-ring';
      const content = document.createElement('span');
      content.className = 'ts-percent-content';

      // Move all children into content first, then move the leading <strong> into ring.
      const children = Array.from(li.childNodes);
      children.forEach((node) => content.appendChild(node));

      if (strong?.parentNode === content) {
        ring.appendChild(strong);
      }

      li.appendChild(ring);
      li.appendChild(content);
      li.dataset.tsPercentEnhanced = '1';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enhancePercentageLists(document), { once: true });
} else {
  enhancePercentageLists(document);
}

// Shopify theme editor / dynamic section reloads
document.addEventListener('shopify:section:load', (event) => {
  const target = event?.target;
  if (target instanceof HTMLElement) enhancePercentageLists(target);
});
